import React from 'react'
import FloatingPanel from 'components/floating/floating-panel'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import CloseIcon from '@mui/icons-material/Close'
import IconButton from '@mui/material/IconButton'
import Typography from '@mui/material/Typography'
import { useTranslation } from 'react-i18next'
import { TEST_IDS } from 'test-ids'

export default function EditBoundaryHelpBubble({
  onClose,
}: {
  onClose: () => void
}) {
  const { t } = useTranslation()
  return (
    <FloatingPanel
      $position="topRight"
      $background="white"
      $maxWidth="25vw"
      id={TEST_IDS.editBoundaryHelpBubble}
      data-testid={TEST_IDS.editBoundaryHelpBubble}
    >
      <div style={{ position: 'relative', paddingRight: 24 }}>
        <IconButton
          size="small"
          onClick={onClose}
          aria-label="Close help"
          style={{ position: 'absolute', top: 0, right: 0, zIndex: 2 }}
        >
          <CloseIcon />
        </IconButton>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <InfoOutlinedIcon color="primary" />
          <Typography
            variant="body2"
            style={{ flex: 1, whiteSpace: 'pre-line', wordBreak: 'break-word' }}
          >
            {t('edit_boundary_help')}
          </Typography>
        </div>
      </div>
    </FloatingPanel>
  )
}
